<template>
  <div
    class="modal fade"
    id="editKPIGroupDialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <form id="editKPIGroupDialogForm">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>
            <h4 class="modal-title">
              <b>{{ lang.KM4006 }}</b>
            </h4>
            <p>
              <b>{{ lang.KM4007 }}:</b>
              {{ nameOfSelectedClient }}
              <b>/ {{ lang.KM4027 }}:</b>
              {{ nameOfSelectedKpiGroup }}
              <b>/ {{ lang.KM4010 }}:</b>
              {{ nameOfSelectedEvaluationRuleGuid }}
            </p>
          </div>
          <div class="modal-body">
            <div class="panel panel-default">
              <div class="panel-body">
                <div class="col-md-6" style="padding-left: 0">
                  <div
                    class="form-group searchbar col-md-6"
                    style="padding-left: 15px"
                  >
                    <input
                      type="search"
                      class="form-control"
                      :placeholder="lang.KM4013"
                      v-model="filterKpiGroupString"
                      @input="doFilterKpiGroups()"
                      @keydown.enter.prevent
                    />
                  </div>
                  <div
                    class="form-group searchbar col-md-6"
                    style="padding-left: 15px; top: 9px"
                  >
                    <select2
                      class="form-control"
                      v-model="selectedClientGuid"
                      @change="
                        createNewKpiGroup(), getKpiGroupsOfSelectedClient()
                      "
                      :disabled="
                        feature.isAudiTarget &&
                        feature.isEnabled('audi_importers')
                      "
                    >
                      <option
                        v-for="client in clientList"
                        :key="client.ClientGuid"
                        :value="client.ClientGuid"
                      >
                        {{ client.ClientName }}
                      </option>
                    </select2>
                  </div>
                  <div class="table-container" style="clear: both">
                    <table class="table table-striped table-hover">
                      <thead>
                        <tr>
                          <!-- <th class="text-center" style="width:20%;">{{lang.KM4012}}</th> -->
                          <th class="text-center" style="width: 20%">
                            {{ lang.KM4036 }}
                          </th>
                          <th class="text-center" style="width: 25%">
                            {{ lang.KM4000 }}
                          </th>
                          <th class="text-center" style="width: 55%">
                            {{ lang.KM4001 }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          role="button"
                          :key="kpiGroup.KPIGroupGuid"
                          @click="
                            (selectedKpiGroupGuid = kpiGroup.KPIGroupGuid),
                              getSelectedKpiGroupInformation()
                          "
                          :class="{
                            info:
                              selectedKpiGroupGuid === kpiGroup.KPIGroupGuid,
                          }"
                          v-for="kpiGroup in filteredKpiGroups"
                        >
                          <!-- <td style="width:20%;">{{ kpiGroup.KPIGroupId }}</td> -->
                          <td style="width: 20%">
                            {{ kpiGroup.KPIGroupPosition }}
                          </td>
                          <td style="width: 25%">
                            {{ kpiGroup.KPIGroupCode }}
                          </td>
                          <td style="width: 55%">
                            {{ kpiGroup.KPIGroupShortText }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-6" style="padding-right: 0">
                  <ul
                    class="nav nav-tabs nav-kpi-group-edit"
                    style="margin-bottom: 15px"
                  >
                    <li class="active">
                      <a
                        href="#editKpiGroupTab"
                        data-toggle="tab"
                        @click="
                          (selectedTab = 'editKpiGroupTab'), getKpiGroupData()
                        "
                        >{{ lang.KM4014 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#kpiOrderTab"
                        data-toggle="tab"
                        @click="
                          (selectedTab = 'kpiOrderTab'), getKpiGroupData()
                        "
                        >{{ lang.KM4017 }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="#kpiGroupOrderTab"
                        data-toggle="tab"
                        @click="
                          (selectedTab = 'kpiGroupOrderTab'), getKpiGroupData()
                        "
                        >{{ lang.KM4037 }}</a
                      >
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane fade active in" id="editKpiGroupTab">
                      <form class="form-horizontal">
                        <div class="form-group">
                          <label
                            for="inputKpiGroupCode"
                            id="inputKpiGroupCodeLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM4000 }} *
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              class="form-control"
                              maxlength="200"
                              id="inputKpiGroupCode"
                              @input="selectedKpiGroupDirty = true"
                              v-model="selectedKpiGroupInformation.KPIGroupCode"
                              required
                            />
                            <span
                              v-show="inputHasError('inputKpiGroupCode')"
                              class="help-block error text-danger"
                              >{{ lang.KM4029 }}</span
                            >
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiGroupCodeLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM4032 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiGroupShortText"
                            id="inputKpiGroupShortTextLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM4001 }} *
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              class="form-control"
                              maxlength="50"
                              id="inputKpiGroupShortText"
                              @input="selectedKpiGroupDirty = true"
                              v-model="
                                selectedKpiGroupInformation.KPIGroupShortText
                              "
                              required
                            />
                            <span
                              v-show="inputHasError('inputKpiGroupShortText')"
                              class="help-block error text-danger"
                              >{{ lang.KM4029 }}</span
                            >
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiGroupShortTextLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM4033 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiGroupLongText"
                            id="inputKpiGroupLongTextLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM4004 }} *
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="text"
                              class="form-control"
                              maxlength="200"
                              id="inputKpiGroupLongText"
                              @input="selectedKpiGroupDirty = true"
                              v-model="
                                selectedKpiGroupInformation.KPIGroupLongText
                              "
                              required
                            />
                            <span
                              v-show="inputHasError('inputKpiGroupLongText')"
                              class="help-block error text-danger"
                              >{{ lang.KM4029 }}</span
                            >
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="inputKpiGroupLongTextLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM4034 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="KPIGroupWeightInput"
                            id="KPIGroupWeightInputLabel"
                            class="col-md-3 control-label"
                          >
                            {{ lang.KM4031 }}
                            <i class="material-icons md-18">help_outline</i>
                          </label>
                          <div class="col-md-9">
                            <input
                              type="number"
                              class="form-control"
                              id="KPIGroupWeightInput"
                              min="0"
                              max="100"
                              step="0.01"
                              @input="selectedKpiGroupDirty = true"
                              v-model.number="
                                selectedKpiGroupInformation.KPIGroupWeight
                              "
                            />
                          </div>
                          <b-tooltip
                            ref="tooltip"
                            target="KPIGroupWeightInputLabel"
                            placement="right"
                            :delay="globals.tooltipDelay"
                            >{{ lang.KM4035 }}</b-tooltip
                          >
                        </div>
                        <div class="form-group">
                          <label
                            for="KPIGroupProjectSelect"
                            class="col-md-3 control-label"
                            >{{ lang.KM4008 }} *</label
                          >
                          <div class="col-md-9">
                            <select2
                              class="form-control"
                              id="KPIGroupProjectSelect"
                              v-model="selectedProjectGuid"
                              :placeholder="lang.KM4009"
                              @change="selectedKpiGroupDirty = true"
                              required
                            >
                              <option></option>
                              <option
                                v-for="project in clientProjectList"
                                :key="project.ProjectGuid"
                                :value="project.ProjectGuid"
                              >
                                {{ project.ProjectName }}
                              </option>
                            </select2>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            for="KPIGroupsSelectEvaluation"
                            class="col-md-3 control-label"
                            >{{ lang.KM4010 }} *</label
                          >
                          <div class="col-md-9">
                            <select2
                              class="form-control"
                              id="KPIGroupsSelectEvaluation"
                              v-model="
                                selectedKpiGroupInformation.KPIEvaluationRuleGuid
                              "
                              :placeholder="lang.KM4011"
                              @change="selectedKpiGroupDirty = true"
                              required
                            >
                              <option></option>
                              <option
                                v-for="evaluation in kpiGroupEvaluationRulesList"
                                :key="evaluation.EvaluationRuleGuid"
                                :value="evaluation.EvaluationRuleGuid"
                              >
                                {{ evaluation.EvaluationRule }}
                              </option>
                            </select2>
                          </div>
                        </div>
                        <div class="form-group">
                          <label
                            for="inputKpiGroupDescription"
                            class="col-md-3 control-label"
                            >{{ lang.KM4005 }}</label
                          >
                          <div class="col-md-9">
                            <div class="form-group nopadding">
                              <textarea
                                rows="3"
                                type="text"
                                class="form-control"
                                maxlength="500"
                                id="inputKpiGroupDescription"
                                @input="selectedKpiGroupDirty = true"
                                v-model="
                                  selectedKpiGroupInformation.KPIGroupDescription
                                "
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </form>
                      <div style="margin: 25px 0 25px 0">
                        <b-alert
                          variant="danger"
                          dismissible
                          :show="showAlert"
                          @dismissed="showAlert = false"
                          >{{ lang.KM4028 }}</b-alert
                        >
                      </div>
                      <div>
                        <button
                          type="button"
                          class="btn btn-raised btn-top-bar"
                          :disabled="
                            !selectedKpiGroupGuid && !selectedKpiGroupDirty
                          "
                          @click="createNewKpiGroup()"
                        >
                          <i class="material-icons md-36">add_box</i>
                          <br />
                          {{ lang.KM4015 }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-raised btn-top-bar"
                          :class="{ 'btn-warning': selectedKpiGroupDirty }"
                          :disabled="
                            !selectedKpiGroupGuid && !selectedKpiGroupDirty
                          "
                          @click="validateBeforeSubmit('editKPIGroupDialog')"
                        >
                          <i class="material-icons md-36">save</i>
                          <br />
                          {{ lang.KM4003 }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-raised btn-top-bar"
                          :disabled="!selectedKpiGroupGuid"
                          @click="openDeleteKpiGroupConfirmationDialog()"
                        >
                          <i class="material-icons md-36">delete</i>
                          <br />
                          {{ lang.KM4016 }}
                        </button>
                      </div>
                    </div>
                    <div class="tab-pane fade" id="kpiOrderTab">
                      <div class="table-container table-positions">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th style="width: 80%" class="text-center">
                                {{ lang.KM4018 }}
                              </th>
                              <th style="width: 20%">{{ lang.KM4019 }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="kpi in kpisOfSelectedKpiGroup"
                              :key="kpi.KPIGroupPosition"
                            >
                              <td style="width: 80%">
                                {{ kpi.KPIShortText }}
                              </td>
                              <td class="nopadding">
                                <div
                                  class="form-group nopadding"
                                  style="width: 60%; float: left"
                                >
                                  <select
                                    class="form-control text-center nopadding"
                                    v-model="kpi.KPIGroupPosition"
                                    @change="
                                      reorderKpisInKpiGroup(),
                                        (changeKpiOrderDirty = true)
                                    "
                                  >
                                    <option
                                      v-for="kpi2 in kpisOfSelectedKpiGroup"
                                      :key="kpi2.KPIGroupPosition"
                                      :value="kpi2.KPIGroupPosition"
                                    >
                                      {{ kpi2.KPIGroupPosition }}
                                    </option>
                                  </select>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        :class="{ 'btn-warning': changeKpiOrderDirty }"
                        :disabled="kpisOfSelectedKpiGroup.length < 1"
                        @click="saveKpisNewOrder()"
                      >
                        {{ lang.KM4030 }}
                      </button>
                    </div>
                    <div class="tab-pane fade" id="kpiGroupOrderTab">
                      <div class="table-container table-positions">
                        <table class="table table-striped table-hover">
                          <thead>
                            <tr>
                              <th style="width: 80%" class="text-center">
                                {{ lang.KM4038 }}
                              </th>
                              <th style="width: 20%">{{ lang.KM4039 }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="kpiGroup in kpiGroupsOfSelectedClient"
                              :key="kpiGroup.KPIGroupPosition"
                            >
                              <td style="width: 80%">
                                {{ kpiGroup.KPIGroupShortText }}
                              </td>
                              <td class="nopadding">
                                <div
                                  class="form-group nopadding"
                                  style="width: 60%; float: left"
                                >
                                  <select
                                    class="form-control text-center nopadding"
                                    v-model="kpiGroup.KPIGroupPosition"
                                    @change="
                                      reorderKpiGroups(),
                                        (changeKpiGroupOrderDirty = true)
                                    "
                                  >
                                    <option
                                      v-for="kpiGroup2 in kpiGroupsOfSelectedClient"
                                      :key="kpiGroup2.KPIGroupPosition"
                                      :value="kpiGroup2.KPIGroupPosition"
                                    >
                                      {{ kpiGroup2.KPIGroupPosition }}
                                    </option>
                                  </select>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        class="btn btn-raised btn-default"
                        :class="{ 'btn-warning': changeKpiGroupOrderDirty }"
                        :disabled="kpiGroupsOfSelectedClient.length < 1"
                        @click="saveKpiGroupsNewOrder()"
                      >
                        {{ lang.KM4030 }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.KM4002 }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "../Tools/Select2";

export default {
  name: "KPIGroupEditModal",
  components: {
    Select2,
  },
  mounted() {
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    $("#editKPIGroupDialog").on("hide.bs.modal", (e) => {
      this.$emit("dialogClosed");
    });

    // Register global events
    this.globals.$off("KPIGroupDeleteModalYesConfirmation");
    this.globals.$on("KPIGroupDeleteModalYesConfirmation", () => {
      this.deleteSelectedKpiGroup();
    });
  },
  props: [
    "showDialog",
    "clientList",
    "projectList",
    "kpiGroupEvaluationRulesList",
    "selectedClientForKpiGroups",
  ],
  watch: {
    showDialog() {
      this.showDialog
        ? this.openEditKPIGroupDialog()
        : this.closeEditKPIGroupDialog();
    },
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this);
    },
  },
  data() {
    return {
      selectedKpiGroupInformation: {
        KPIGroupGuid: "",
        KPIGroupCode: "",
        KPIGroupShortText: "",
        KPIGroupLongText: "",
        KPIGroupDescription: "",
        KPIEvaluationRuleGuid: "",
        Projects: [],
      },
      selectedTab: "editKpiGroupTab",
      selectedKpiGroupGuid: "",
      filterKpiGroupString: "",
      filteredKpiGroups: [],
      selectedKpiGroupDirty: false,
      changeKpiOrderDirty: false,
      changeKpiGroupOrderDirty: false,
      kpiGroupsOfSelectedClient: [],
      kpisOfSelectedKpiGroup: [],
      selectedClientGuid: "",
      selectedProjectGuid: "",
      clientProjectList: [],
      showAlert: false,
      invalidInputIds: [],
      selectedEvaluationRule: "",
      lang: {
        KM4000: "KPI Group Code",
        KM4001: "KPI Group Shorttext",
        KM4002: "Close",
        KM4003: "Save",
        KM4004: "KPI Group Longtext",
        KM4005: "Description",
        KM4006: "KPI Group Management",
        KM4007: "Client",
        KM4008: "Project",
        KM4009: "Please select a project...",
        KM4010: "Evaluation rule",
        KM4011: "Please select an evaluation rule...",
        KM4012: "ID",
        KM4013: "Filter",
        KM4014: "Edit KPI Group",
        KM4015: "New",
        KM4016: "Delete",
        KM4017: "KPI Order",
        KM4018: "KPI Shorttext",
        KM4019: "Position",
        KM4020: "Delete KPI Group",
        KM4021: "Do you really want to delete the following KPI group?",
        KM4022: "Yes",
        KM4023: "No",
        KM4024: "ID",
        KM4025: "KPI Group Code",
        KM4026: "KPI Group Shorttext",
        KM4027: "KPI Group",
        KM4028:
          "Your inputs are incorrect. Please check the fields marked in red!",
        KM4029: "This is a required entry!",
        KM4030: "Save positions",
        KM4031: "Weight",
        KM4032: "KPI Group Code – max. 200 characters",
        KM4033:
          "KPI Group Shorttext – max. 50 characters, will be visible in Cockpit",
        KM4034: "KPI Group Longtext – max. 200 characters",
        KM4035: "Weight of the KPI Group related to other KPI Groups",
        KM4036: "Position",
        KM4037: "KPI Group Order",
        KM4038: "KPI Group Shorttext",
        KM4039: "Position",
      },
    };
  },
  computed: {
    nameOfSelectedClient() {
      if (this.selectedClientGuid === "") return " - ";
      let client = this.clientList.find(
        (c) => c.ClientGuid === this.selectedClientGuid
      );
      return client ? client.ClientName : " - ";
    },
    nameOfSelectedKpiGroup() {
      if (this.selectedKpiGroupGuid === "") return " - ";
      let kpiGroup = this.kpiGroupsOfSelectedClient.find(
        (element) => element.KPIGroupGuid === this.selectedKpiGroupGuid
      );
      return kpiGroup ? kpiGroup.KPIGroupShortText : " - ";
    },
    nameOfSelectedEvaluationRuleGuid() {
      let selectedEvaluationRuleGuid = this.selectedKpiGroupInformation
        .KPIEvaluationRuleGuid;
      if (!selectedEvaluationRuleGuid) return " - ";
      let evaluationRule = this.kpiGroupEvaluationRulesList.find(
        (element) => element.EvaluationRuleGuid === selectedEvaluationRuleGuid
      );
      this.selectedEvaluationRule = evaluationRule.EvaluationRule || " - ";
      return this.selectedEvaluationRule;
    },
  },
  methods: {
    initEditKPIGroupDialog() {
      this.createNewKpiGroup();
      this.selectedClientGuid = this.selectedClientForKpiGroups;
      this.changeKpiGroupOrderDirty = false;
    },
    // reset form states and empty input fields
    createNewKpiGroup() {
      this.selectedKpiGroupInformation = {
        KPIGroupGuid: "",
        KPIGroupCode: "",
        KPIGroupShortText: "",
        KPIGroupLongText: "",
        KPIGroupDescription: "",
        KPIEvaluationRuleGuid: "",
        Projects: [],
      };
      this.selectedKpiGroupGuid = "";
      this.selectedEvaluationRule = "";
      this.selectedProjectGuid = "";
      this.kpisOfSelectedKpiGroup = [];
      this.selectedKpiGroupDirty = false;
      this.showAlert = false;
      this.changeKpiOrderDirty = false;
      this.changeKpiGroupOrderDirty = false;
      this.resetValidationErrors("editKPIGroupDialog");
    },
    openEditKPIGroupDialog() {
      $("#editKPIGroupDialog").modal("show");
      this.initEditKPIGroupDialog();
      this.getKpiGroupsOfSelectedClient();
    },
    closeEditKPIGroupDialog() {
      $("#editKPIGroupDialog").modal("hide");
    },
    getKpiGroupsOfSelectedClient() {
      let queryString = `api/KPIGroups/Client/${this.selectedClientGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          if (!_.isEmpty(data)) {
            this.kpiGroupsOfSelectedClient = data;
            this.kpiGroupsOfSelectedClient.forEach((kpiGroup) => {
              if (!kpiGroup.Projects) kpiGroup.Projects = [];
            });
          } else this.kpiGroupsOfSelectedClient = [];
          this.sortKpiGroupsByPosition();
          this.doFilterKpiGroups();
          this.filterClientProjectList();
        },
        error: () => {
          console.error("Error on GET in getKpiGroupsOfSelectedClient()");
          this.globals.showErrorSnackbar("KPI Group data request failed");
        },
      });
    },
    doFilterKpiGroups() {
      // Reset filtering when search string is empty
      if (
        !this.kpiGroupsOfSelectedClient ||
        this.kpiGroupsOfSelectedClient.length < 1
      ) {
        this.filteredKpiGroups = this.kpiGroupsOfSelectedClient;
        return;
      }

      let words = this.filterKpiGroupString.split(" ");
      let keys = ["KPIGroupId", "KPIGroupCode", "KPIGroupShortText"];

      const kpiGroupFilter = (kpiGroup) => {
        let isKpiGroupInList = this.kpiGroupsOfSelectedClient.find(
          (element) => element.KPIGroupGuid === kpiGroup.KPIGroupGuid
        );
        if (!isKpiGroupInList) return false;

        let containsSearch = false;
        words.forEach((word) => {
          keys.forEach((key) => {
            if (
              kpiGroup[key] &&
              kpiGroup[key]
                .toString()
                .toLowerCase()
                .indexOf(word.toLowerCase()) > -1
            ) {
              containsSearch = true;
              return;
            }
          });
        });
        return containsSearch;
      };
      this.filteredKpiGroups = this.kpiGroupsOfSelectedClient.filter(
        kpiGroupFilter
      );
    },
    filterClientProjectList() {
      this.clientProjectList = [];
      if (this.selectedClientGuid) {
        let listOfClientProjects = this.projectList.filter(
          (project) => project.ClientGuid === this.selectedClientGuid
        );
        if (listOfClientProjects.length > 0) {
          this.clientProjectList = listOfClientProjects[0].Projects;
          this.sortClientProjectList();
        }
      }
    },
    sortClientProjectList() {
      this.clientProjectList.sort((a, b) => {
        // Sort projects by name
        if (a.ProjectName.toLowerCase() < b.ProjectName.toLowerCase())
          return -1;
        if (a.ProjectName.toLowerCase() > b.ProjectName.toLowerCase()) return 1;
        return 0;
      });
    },
    getKpisOfSelectedKpiGroup() {
      let queryString = `api/KPIGroups/${this.selectedKpiGroupGuid}`;

      $.ajax({
        method: "GET",
        url: queryString,
        success: (data) => {
          this.selectedKpiGroupInformation = data[0] || {};
          this.selectedProjectGuid =
            this.selectedKpiGroupInformation.Projects.length > 0
              ? this.selectedKpiGroupInformation.Projects[0].ProjectGuid
              : "";

          this.kpisOfSelectedKpiGroup = data[0].KPIs || [];
          this.sortKpisByGroupPosition();
        },
        error: () => {
          console.error(
            "KPI data request failed in getKpisOfSelectedKpiGroup()"
          );
          this.globals.showErrorSnackbar("KPI data request failed");
        },
      });
    },
    getSelectedKpiGroupInformation() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Read")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Read");
        this.selectedKpiGroupGuid = "";
        return;
      }

      if (!this.selectedKpiGroupGuid) return;
      this.getKpisOfSelectedKpiGroup();
      this.selectedKpiGroupDirty = false;
      this.changeKpiOrderDirty = false;
      this.showAlert = false;
      this.resetValidationErrors("editKPIGroupDialog");
    },
    getKpiGroupData() {
      if (
        this.selectedTab === "editKpiGroupTab" ||
        this.selectedTab === "kpiOrderTab"
      )
        this.getSelectedKpiGroupInformation();
      if (this.selectedTab === "kpiGroupOrderTab") {
        this.changeKpiGroupOrderDirty = false;
        this.getKpiGroupsOfSelectedClient();
      }
    },
    getClientProject(projectGuid) {
      let result = this.clientProjectList.find(
        (element) => element.ProjectGuid === projectGuid
      );
      return { ProjectGuid: result.ProjectGuid };
    },
    saveEditKPIGroupDialogData() {
      if (
        !this.globals.isAccessAllowed("LoopOp_KPIGroups_Create") &&
        !this.selectedKpiGroupGuid
      ) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Create");
        return;
      } else if (
        !this.globals.isAccessAllowed("LoopOp_KPIGroups_Update") &&
        this.selectedKpiGroupGuid
      ) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Update");
        return;
      }

      let queryString = !this.selectedKpiGroupGuid
        ? `api/KPIGroups/Client/${this.selectedClientGuid}` // new kpi group
        : `api/KPIGroups/${this.selectedKpiGroupGuid}`; // update exisiting kpi group

      this.selectedKpiGroupInformation.Projects = [];
      if (this.selectedProjectGuid) {
        let clientProject = this.getClientProject(this.selectedProjectGuid);
        this.selectedKpiGroupInformation.Projects.push(clientProject);
      }

      if (this.selectedKpiGroupInformation.KPIGroupWeight === "")
        delete this.selectedKpiGroupInformation.KPIGroupWeight;

      if (!this.selectedKpiGroupGuid) {
        // create new kpi group
        $.ajax({
          method: "POST",
          url: queryString,
          data: JSON.stringify(this.selectedKpiGroupInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            this.globals.showSuccessSnackbar("KPI Group creation successful");
            this.selectedKpiGroupGuid = data[0].KPIGroupGuid;
            this.selectedKpiGroupInformation = _.cloneDeep(data[0]);
            this.selectedKpiGroupDirty = false;
            this.getKpiGroupsOfSelectedClient();
          },
          error: () => {
            console.error("Error on POST in saveEditKPIGroupDialogData()");
            this.globals.showErrorSnackbar("KPI Group creation failed");
          },
        });
      } else {
        // update exisiting kpi group
        $.ajax({
          method: "PUT",
          url: queryString,
          data: JSON.stringify(this.selectedKpiGroupInformation),
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          success: (data) => {
            this.globals.showSuccessSnackbar("KPI Group update successful");
            this.selectedKpiGroupDirty = false;
            this.getKpiGroupsOfSelectedClient();
          },
          error: () => {
            console.error("Error on PUT in saveEditKPIGroupDialogData()");
            this.globals.showErrorSnackbar("KPI Group update failed");
          },
        });
      }
    },
    openDeleteKpiGroupConfirmationDialog() {
      if (!this.globals.isAccessAllowed("LoopOp_KPIGroups_Delete")) {
        this.globals.showErrorSnackbar("Access forbidden");
        console.error("Access forbidden: LoopOp_KPIGroups_Delete");
        return;
      }

      this.globals.$emit(
        "openGlobalConfirmationDialog",
        this.getDeleteDialogData()
      );
    },
    getDeleteDialogData() {
      return {
        initiator: "KPIGroupDeleteModal",
        confirmationTitle: this.lang.KM4020,
        colorRed: true,
        yesButtonText: this.lang.KM4022,
        noButtonText: this.lang.KM4023,
        htmlText: `<p><b>${this.lang.KM4021}</b></p>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.KM4024}</label>
          <label class="col-md-8 text-black">${this.selectedKpiGroupInformation.KPIGroupId}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.KM4025}</label>
          <label class="col-md-8 text-black">${this.selectedKpiGroupInformation.KPIGroupCode}</label>
        </div>
        <div class="form-group">
          <label class="col-md-4 text-black">${this.lang.KM4026}</label>
          <label class="col-md-8 text-black">${this.selectedKpiGroupInformation.KPIGroupShortText}</label>
        </div>`,
      };
    },
    deleteSelectedKpiGroup() {
      let queryString = `api/KPIGroups/${this.selectedKpiGroupGuid}`;

      $.ajax({
        method: "DELETE",
        url: queryString,
        success: (data) => {
          // If delete was successful, refresh displayed data and hide dialog
          this.globals.showSuccessSnackbar("KPI group deletion successful");
          this.createNewKpiGroup();
          this.getKpiGroupsOfSelectedClient();
          this.$forceUpdate();
        },
        error: () => {
          console.error(
            "KPI group deletion failed in deleteSelectedKpiGroup()"
          );
          this.globals.showErrorSnackbar("KPI group deletion failed");
        },
      });
    },
    // Reorders kpis of a kpi group after the position of a kpi changed
    reorderKpisInKpiGroup() {
      let numberOfKpis = this.kpisOfSelectedKpiGroup.length,
        allPositions = _.range(1, numberOfKpis + 1),
        missingPos = 0,
        newPos = 0,
        kpiGuid = "";

      // Find missing position number and the position and code of the changed kpi
      allPositions.forEach((position, index) => {
        if (position !== this.kpisOfSelectedKpiGroup[index].KPIGroupPosition) {
          missingPos = position;
          newPos = this.kpisOfSelectedKpiGroup[index].KPIGroupPosition;
          kpiGuid = this.kpisOfSelectedKpiGroup[index].KPIGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpisOfSelectedKpiGroup[i].KPIGuid !== kpiGuid) {
          // Do NOT move the changed kpi
          if (
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition < missingPos &&
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition >= newPos
          )
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition++;
          if (
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition > missingPos &&
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition <= newPos
          )
            this.kpisOfSelectedKpiGroup[i].KPIGroupPosition--;
        }
      }
      this.sortKpisByGroupPosition();
    },
    // Sorts the available kpis by their position number
    sortKpisByGroupPosition() {
      if (this.kpisOfSelectedKpiGroup.length < 0) return;
      this.kpisOfSelectedKpiGroup.sort(
        (a, b) => a.KPIGroupPosition - b.KPIGroupPosition
      );
    },
    saveKpisNewOrder() {
      // save new kpi order in selected kpi group
      let queryString = `api/KPIGroups/${this.selectedKpiGroupGuid}`;
      this.selectedKpiGroupInformation.KPIs = this.kpisOfSelectedKpiGroup;

      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(this.selectedKpiGroupInformation),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar("Save KPI Position successful");
          this.changeKpiOrderDirty = false;
          this.getKpiGroupsOfSelectedClient();
        },
        error: () => {
          console.error("Error on PUT in saveKpisNewOrder()");
          this.globals.showErrorSnackbar("Save KPI Position failed");
        },
      });
    },
    // Reorders kpiGroups from a client after the position of a kpiGroup changed
    reorderKpiGroups() {
      let numberOfKpiGroups = this.kpiGroupsOfSelectedClient.length,
        allPositions = _.range(1, numberOfKpiGroups + 1),
        missingPos = 0,
        newPos = 0,
        kpiGroupGuid = "";

      // Find missing position number and the position and code of the changed kpiGroup
      allPositions.forEach((position, index) => {
        if (
          position !== this.kpiGroupsOfSelectedClient[index].KPIGroupPosition
        ) {
          missingPos = position;
          newPos = this.kpiGroupsOfSelectedClient[index].KPIGroupPosition;
          kpiGroupGuid = this.kpiGroupsOfSelectedClient[index].KPIGroupGuid;
        }
      });

      if (missingPos === 0) return; // No position missing -> no value changed

      // Move position numbers between new position number and missing position number
      for (var i = 0; i < allPositions.length; i++) {
        if (this.kpiGroupsOfSelectedClient[i].KPIGroupGuid !== kpiGroupGuid) {
          // Do NOT move the changed kpiGroup
          if (
            this.kpiGroupsOfSelectedClient[i].KPIGroupPosition < missingPos &&
            this.kpiGroupsOfSelectedClient[i].KPIGroupPosition >= newPos
          )
            this.kpiGroupsOfSelectedClient[i].KPIGroupPosition++;
          if (
            this.kpiGroupsOfSelectedClient[i].KPIGroupPosition > missingPos &&
            this.kpiGroupsOfSelectedClient[i].KPIGroupPosition <= newPos
          )
            this.kpiGroupsOfSelectedClient[i].KPIGroupPosition--;
        }
      }
      this.sortKpiGroupsByPosition();
    },
    // Sorts the available kpi groups by their position number
    sortKpiGroupsByPosition() {
      if (this.kpiGroupsOfSelectedClient.length < 0) return;
      this.kpiGroupsOfSelectedClient.sort(
        (a, b) => a.KPIGroupPosition - b.KPIGroupPosition
      );
    },
    generateKpiGroupNewOrderPayload() {
      return this.kpiGroupsOfSelectedClient.map((kpiGroup) => {
        return {
          KPIGroupGuid: kpiGroup.KPIGroupGuid,
          KPIGroupPosition: kpiGroup.KPIGroupPosition,
        };
      });
    },
    saveKpiGroupsNewOrder() {
      let queryString = `api/KPIGroups/Positions/Client/${this.selectedClientGuid}`;
      let payload = this.generateKpiGroupNewOrderPayload();
      $.ajax({
        method: "PUT",
        url: queryString,
        data: JSON.stringify(payload),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          this.globals.showSuccessSnackbar("Save KPI Group Postion successful");
          this.changeKpiGroupOrderDirty = false;
          this.getKpiGroupsOfSelectedClient();
        },
        error: () => {
          console.error("Error on PUT in saveKpiGroupsNewOrder()");
          this.globals.showErrorSnackbar("Save KPI Group Position failed");
        },
      });
    },
    // Triggers input validation and ensures further progress if validation was successful
    validateBeforeSubmit(dialog) {
      var result = true;
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          result = this.validateInput(elements[i].id) && result; // If only one input is invalid, the whole form is invalid
      }
      if (dialog === "editKPIGroupDialog") {
        this.showAlert = !result;
        if (!result) return;
        this.saveEditKPIGroupDialogData();
      }
    },
    // Validates an input with the given id, changes the input color depending on the validation result and returns the result
    validateInput(id) {
      var result = $("#" + id)[0].checkValidity(); // Checks validation depending on the input type or a given pattern in the template
      if (result) {
        $("#" + id)
          .parent()
          .parent()
          .removeClass("has-error"); // has-error has to be added to the form-group element
        var idx = this.invalidInputIds.indexOf(id);
        if (idx > -1) {
          this.invalidInputIds.splice(idx, 1); // Remove from list, if valid
        }
      } else {
        $("#" + id)
          .parent()
          .parent()
          .addClass("has-error");
        if (this.invalidInputIds.indexOf(id) < 0) this.invalidInputIds.push(id); // Add to list, if invalid
      }
      return result;
    },
    // Returns true if an input has a validation error, otherwise false
    inputHasError(id) {
      return this.invalidInputIds.indexOf(id) > -1 ? true : false;
    },
    // Resets all validation errors for the given dialog
    resetValidationErrors(dialog) {
      var elements = $("#" + dialog).find(":input"); // Returns a list of all inputs on the dialog
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].id.length > 0)
          $("#" + elements[i].id)
            .parent()
            .parent()
            .removeClass("has-error");
      }
      this.invalidInputIds = [];
    },
  },
};
</script>

<style scoped>
.modal-lg {
  width: calc(100vw - 300px);
}

.table-container {
  height: calc(100vh - 300px);
  overflow-y: auto;
}

.table-positions {
  height: calc(100vh - 355px);
}

.modal-content {
  background-color: #eee;
}

#editKPIGroupDialog .panel-body {
  padding: 0 !important;
}

.modal-footer .btn-default {
  background: rgb(190, 190, 190);
}

.btn-top-bar.btn.btn-raised {
  margin-bottom: 10px;
}
.btn-top-bar.btn.btn-raised.btn-warning {
  background-color: #ff5722;
}

.btn.btn-raised.btn-warning:hover {
  background-color: #ec5122ab;
}

.nav-kpi-group-edit {
  background-color: var(--color-primary);
  padding: 0px;
}

.nav-kpi-group-edit > li {
  text-align: center;
  float: none;
  display: inline-block;
}

.nav-kpi-group-edit > li.active {
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-kpi-group-edit > li.active > a {
  font-weight: bold;
}

#editKPIGroupDialog .form-horizontal .form-group {
  margin: 0;
}

#editKpiGroupTab .form-group > label > i.material-icons {
  position: absolute;
  top: 5px;
  right: -5px;
}
</style>



// WEBPACK FOOTER //
// KPIGroupEditModal.vue?3b52fd12